import React from "react";
import { Wrench, Clock, ShieldCheck, FileText, PhoneCall, CircleCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurMaintenancePromise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [{
    title: "24/7 Emergency Response",
    description: "Maintenance issues don't stick to business hours. Our team is on standby around the clock to handle urgent repairs, protecting your property and your peace of mind.",
    icon: PhoneCall
  }, {
    title: "Vetted Vendor Network",
    description: "We work exclusively with licensed, insured, and trusted local professionals in Abilene. Every technician is screened to ensure high-quality workmanship and safety.",
    icon: ShieldCheck
  }, {
    title: "Rapid Coordination",
    description: "From the moment a request is lodged, our streamlined process ensures quick dispatch and resolution, minimizing downtime for tenants and costs for owners.",
    icon: Clock
  }, {
    title: "Transparent Reporting",
    description: "Stay in the loop with real-time updates and detailed financial reports. You'll see exactly what was fixed and the associated costs, with no hidden fees.",
    icon: FileText
  }];
  return;
}